import React from 'react';
import { IoEyeOutline } from 'react-icons/io5';

function TabsPanel({ title, length, btnText }) {
  return (
    <>
      <div className="main-proc h-[120px] w-[20vw] rounded-xl mt-5 pr-4 ml-3 mr-4 flex flex-col justify-center">
        <h6 className="text-white m-2.5 ml-8 text-[1.75rem] font-medium">
          {title}
        </h6>
        <div className="num-views flex justify-between  ">
          <div className="num">
            <h3 className="ml-8 text-white m-1 text-4xl font-bold ">
              {length}
            </h3>
          </div>
        </div>
      </div>
    </>
  );
}

export default TabsPanel;
